import { TextAnonymisationBehaviour } from "@app/integrations/urm/models/prop-tenant-attribute-code";

export class PropPropertyAttributeCode {
  Attc_AttributeCodeID: string;
  Attc_Description: string;
  Attc_AttributeTypeID: string;
  //  Attc_WorkTypeID: string;
  //  Attc_TradeCodeID: string;
  // public bool Attc_AppliesToDecentHomes { get; set; }
  // public string Attc_DecentHomesSurveySection { get; set; }
  // public string Attc_PrintStatus { get; set; }
  Attc_Caution: boolean;
  // public Nullable<decimal> Attc_ReplacementCost { get; set; }
  // public bool Attc_IsPINRequired { get; set; }
  Attc_TextAnonymisationBehaviour: TextAnonymisationBehaviour;
  Attc_AlternateText: string;
}
